/** Server tag badges (`SPACE_TAG_BADGES`, @enbox/shared polish.ts): the icon and name of each id. */
import {
  BookOpen,
  Bug,
  Cat,
  Coffee,
  Crown,
  Dices,
  Flame,
  Flower2,
  Gamepad2,
  Gem,
  Ghost,
  Heart,
  Leaf,
  Moon,
  Music,
  PawPrint,
  Rocket,
  Shield,
  Skull,
  Star,
  Sun,
  Sword,
  Waves,
  Zap,
  type LucideIcon,
} from 'lucide-react';
import type { SpaceTagBadge } from '@enbox/shared';

export const SPACE_TAG_BADGE_ICONS: Record<SpaceTagBadge, LucideIcon> = {
  leaf: Leaf,
  flame: Flame,
  heart: Heart,
  star: Star,
  moon: Moon,
  sun: Sun,
  bolt: Zap,
  skull: Skull,
  crown: Crown,
  sword: Sword,
  shield: Shield,
  gem: Gem,
  music: Music,
  gamepad: Gamepad2,
  paw: PawPrint,
  flower: Flower2,
  ghost: Ghost,
  rocket: Rocket,
  wave: Waves,
  book: BookOpen,
  coffee: Coffee,
  cat: Cat,
  dice: Dices,
  bug: Bug,
};

/** Accessible names of the badge picker's buttons. */
export const SPACE_TAG_BADGE_LABELS: Record<SpaceTagBadge, string> = {
  leaf: 'Leaf',
  flame: 'Flame',
  heart: 'Heart',
  star: 'Star',
  moon: 'Moon',
  sun: 'Sun',
  bolt: 'Bolt',
  skull: 'Skull',
  crown: 'Crown',
  sword: 'Sword',
  shield: 'Shield',
  gem: 'Gem',
  music: 'Music',
  gamepad: 'Gamepad',
  paw: 'Paw',
  flower: 'Flower',
  ghost: 'Ghost',
  rocket: 'Rocket',
  wave: 'Wave',
  book: 'Book',
  coffee: 'Coffee',
  cat: 'Cat',
  dice: 'Dice',
  bug: 'Bug',
};
